import React from 'react';
import { connect } from 'react-redux';
import {
    Card, CardBlock, CardTitle,
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import {Link} from 'react-router-dom';

import ReactTable from "react-table";
import "react-table/react-table.css";

import IconPrint from 'react-icons/lib/fa/print';
import IconOpen from 'react-icons/lib/fa/folder-open-o';
import FAplus from 'react-icons/lib/fa/plus';

import * as actions from '../../actions/ticket';

import {API_URL} from '../../actions/_request';
import {api} from '../../actions/_request';
import _ from "lodash";
// styling
import './style.css';
import Fasearch from 'react-icons/lib/fa/search';
import moment from 'moment';
import Select   from 'react-select';
const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };


const procesos = [
  {label: 'Todos', value: ''},
  {label: 'Inicio', value: 1},
  {label: 'Proceso', value: 2},
  {label: 'Finalizado', value: 3},
 
];

class TicketTable extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
             data: [],
             pages: null,
             loading: false,
             fecha_inicial : moment().format('Y-MM-DD'),
          fecha_final : moment().add(1, 'days').format('Y-MM-DD'),
          proceso:''
        };

        this.toggle = this.toggle.bind(this);
 

    }



    componentDidMount() {

        let self = this;
        // self.props.get_tickets();
        
    }
    handleSelectChange=(select, name)=> {

        
        const value = select === null ? null : select.value;
        this.setState({
           
             
                [name]: value,
                buscar:0,
        
        });
    }



    toggle(evt, prospectoid = null, title = "Agregar ") {

        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            prospectoid : prospectoid,
            title       : title,
        });
    }
      handleInputChange=(event)=> {



    if(event === null) return;
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
       [name]: value
     },()=>{

      
     });

    
    
  }
  search=()=>{
    let self = this;
        api().get(`/tickets/busqueda?fecha_final=${this.state.fecha_final}&fecha_inicio=${this.state.fecha_inicial}&proceso=${this.state.proceso}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                       console.log('response--------->',response.data.datos)
                       self.setState({
                  data : response.data.datos,
                  loading:false,

                },()=>{


     });
                }

            });
  }

    render() {
const { data, pages, loading } = this.state;
console.log('state--->',this.state)
        return(
            <div className="view">

                <div className="view-header ">
                    
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        <div className="row mt-3">
         <div className="col-12 col-md-2"> 
              <div className="form-group">
                  <label >Inicio:</label>
                  <input  type="date" className="form-control" name="fecha_inicial" 
                    value={this.state.fecha_inicial} onChange={this.handleInputChange}/> 
              </div>
          </div>
          <div className="col-12 col-md-2"> 
              <div className="form-group">
                  <label >Final:</label>
                  <input  type="date" className="form-control" name="fecha_final" 
               value={this.state.fecha_final} onChange={this.handleInputChange}/> 
              </div>
          </div>
          <div className="col-12 col-md-3"> 
                    <div className="form-group">
                        <label >Proceso:</label>
                        <Select
                            placeholder=""
                            type="text"
                            name="proceso"
                            options={procesos}
                            value={this.state.proceso }
                            onChange={ (select) => { this.handleSelectChange(select, 'proceso') } }
                           
                            clearable={false}

                        />
                    </div>
                </div>


                <div className="col-12 col-md-4"> 
                    <div className="form-group">
                              <label><br/></label><br/>
                    <Button color='success' onClick={this.search}> <Fasearch/> </Button>  
                    </div>
                    </div>


         
                 
              

                </div>
                            <div className="text-right">
                            

                            <ul className="list-inline mr-3 ">
                              <li className="list-inline-item ml-2"><div className='divredondo' style={{ backgroundColor:  '#0091ea'}} />Inicio</li>
                              <li className="list-inline-item ml-2"><div className='divredondo' style={{ backgroundColor:  '#2962ff'}} />Proceso</li>
                              <li className="list-inline-item ml-2"><div className='divredondo' style={{ backgroundColor:  '#00c853'}} />Finalizado</li>
                              <li className="list-inline-item ml-2"><div className='divredondo' style={{ backgroundColor:  '#FA7052'}} />Garantía</li>
                              <li className="list-inline-item ml-2"><div className='divredondo' style={{ backgroundColor:  'red'}} />Cancelado</li>
                            </ul>

        
                            </div>
                            <ReactTable
                             getTrProps={(state, rowInfo, column) => {
                                 
                                  if(rowInfo === undefined){
                                         
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (e) => {
                                              this.props.history.push('/tickets/ver/'+rowInfo.original.id);
                                            }
                                        } 
                                  
                                    }
                              }}
                              
                              
                              className = "-striped -highlight"
                              columns   = {[
                               
                                {Header: 'Fecha', accessor: 'created_at',maxWidth:180,minWidth:180 , style: { 'textAlign': 'left'},
                                  Filter: ({ filter, onChange }) =>
                                  <input
                                    type="date" 
                                    name="created_at"
                                    onChange={event => onChange(event.target.value)}
                                   value={filter ? filter.value : ""}
                                />
                                              
                                },
                                {Header: 'Tecnico', accessor: 'asignado',maxWidth:150},
                                {Header: 'No.', accessor: 'clave',maxWidth:150},
                                {Header: 'Cliente', accessor: 'cliente'},
                                {
                                    Header: 'Pagado',
                                    accessor: 'pagado',
                                     maxWidth:80,
                                    style: {paddingLeft: '5px', fontSize:'10px' },
                                    Cell: row => (
                                      <span>
                                          <span style={{
                                              color: row.value === 'SI' ? '#2962ff' : '#ff1f1f',
                                              transition: 'all .3s ease'
                                          }}>
                                          &#x25cf;
                                          </span>&nbsp;{row.value}
                                      </span>
                                      )
                                },
                                {   
                                    Header : 'PV' ,
                                    accessor : 'pv',
                                     maxWidth:50,
                                    style: {paddingLeft: '5px', fontSize:'10px' },
                                    Cell: row => (
                                      <span>
                                          <span style={{
                                              color: row.value === 'SI' ? '#2962ff' : '#ff1f1f',
                                              transition: 'all .3s ease'
                                          }}>
                                          &#x25cf;
                                          </span>&nbsp;{row.value}
                                      </span>
                                      )
                                },
                                {
                                    Header: 'Proceso',
                                    accessor: 'processName',
                                     
                                     maxWidth:100,
                                    Cell: row => {
                                        
                                        let bgcolor = '';
                                        let bgcolort = '#dadada';
                                        let w=0;

                                        switch(row.value)
                                        {
                                          case "Inicio":
                                            bgcolor = '#0091ea';  
                                            w=33;   
                                          break;
                                          case "Proceso":
                                            bgcolor = '#2962ff'; 
                                            w=67;    
                                          break;
                                          case "Finalizado":
                                            bgcolor = '#00c853';  
                                            w=100;   
                                          break;
                                          case "Cancelado":
                                            bgcolor = 'red';  
                                            w=100;   
                                          break;
                                          case "Garantina":
                                            bgcolor = '#FA7052';  
                                            w=85;   
                                          break;

                                        }

                                        return (
                                          <div
                                            style={{
                                              width: '100%',
                                              height: '100%',
                                              backgroundColor: `${bgcolort}`,
                                              borderRadius: '2px'
                                            }}
                                          >
                                            <div
                                              style={{
                                                width: `${w}%`,
                                                height: '100%',
                                                backgroundColor: `${bgcolor}`,
                                                borderRadius: '2px',
                                                transition: 'all .2s ease-out'
                                              }}
                                            />
                                          </div>
                                        )
                                    }
                                },
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                     maxWidth:80,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                              
                                                <a href={API_URL+"/ticketsv2/printRecepcion/"+row.original.id} target="_blank">
                                                    <Button color="secondary" className="btn-sm" >
                                                        <IconPrint />
                                                    </Button>
                                                </a>{' '}
                                                
                                               
                                                <Link to={`/tickets/ver/`+row.original.id}>
                                                    <Button color="secondary" className="btn-sm">
                                                        <IconOpen />
                                                    </Button>
                                                </Link>
                                            </div>
                                        )
                                    }
                                }
                              ]}
                              
                              data = {data}
                              filterable 
                              defaultPageSize={25} 
                              defaultFilterMethod={filterCaseInsensitive}

                              
                             
                             
                             
                              
                              SubComponent={ row => {
                                return(
                                    <Card>
                                        <CardBlock>
                                            <CardTitle className="h6 text-uppercase mb-4">Más Información</CardTitle>
                                            <div className='row'>
                                              <div className='col-6'>
                                                <h1 className="h4 text-uppercase">Tecnicos:</h1>
                                              <dl className="row">
                                                <dt className="col-sm-3 text-truncate">Creo Ticket:</dt>
                                                <dd className="col-sm-9">{row.original.creador}</dd>

                                                 <dt className="col-sm-3 text-truncate">Tecnico Asignado</dt>
                                                <dd className="col-sm-9">{row.original.asignado}</dd>

                                                <dt className="col-sm-3 text-truncate">Cobro:</dt>
                                                <dd className="col-sm-9">{row.original.cobro}</dd>                       

                                            </dl>
                                            </div>
                                              <div className='col-6'>
                                                <h1 className="h4 text-uppercase">Cliente:</h1>
                                              <dl className="row">
                                                <dt className="col-sm-3 text-truncate">Razon Social:</dt>
                                                <dd className="col-sm-9">{row.original.empresa}</dd>

                                                 <dt className="col-sm-3 text-truncate">Telefono</dt>
                                                <dd className="col-sm-9">{row.original.telefono}</dd>

                                                <dt className="col-sm-3 text-truncate">Contacto:</dt>
                                                <dd className="col-sm-9">{row.original.contacto}</dd>                       

                                            </dl>
                                            </div>
                                              
                                            </div>




                                             <h1 className="h4 text-uppercase">Ticket:</h1>

                                              
                                                  <dl className="row">  
                                                    <dt className="col-sm-3 text-truncate">Fecha y hora</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.created_at +' '+row.original.hora}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Fecha de Pago</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.fecha_pago }}></dd>
                                                    <dt className="col-sm-3 text-truncate">Factura</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.factura}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Remision</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.remision}}></dd>
                                                                             
                                                    <dt className="col-sm-3 text-truncate">Descripción Recepción</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.descripcion}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Descripción Proceso/ Diagnostico</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.descripcion_proceso}}></dd>
                                                    {
                                                      (row.original.cancelado===1)&&
                                                      <dt className="col-sm-3 text-truncate">Descripción de Cancelado</dt>
                                                    }
                                                    {
                                                      (row.original.cancelado===1)&&
                                                      <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.motivo_cancelado}}></dd>
                                                    }
                                                  </dl>
                                                  {
                                                      (row.original.proceso_id===5)&&
                                                   <dl className="row">  
                                                    <dt className="col-sm-3 text-truncate">Fecha Garantia</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.garantia.fecha}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Tecnico de Garantia</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.garantia.usuario}}></dd>
                                                                             
                                                    <dt className="col-sm-3 text-truncate">Descripcion Garantia</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.garantia.motivo}}></dd>
                                                   
                                                   
                                                  </dl>
                                                }
                                                

                                            


                                            <table className="table">
                                              <thead>
                                                <tr>
                                                  <th>Producto</th>
                                                  <th>Descripción</th> 
                                                  <th>Subtotal</th>
                                                  <th>Iva</th>
                                                  <th>Total</th>                                                 
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {
                                                  row.original.items.map((item, i) => 
                                                  <tr key={i}>
                                                   <td>{item.categoria}</td>
                                                   <td>{item.descripcion}</td>
                                                   <td>{item.subtotal_formato}</td>
                                                   <td>{item.iva_formato}</td>
                                                   <td>{item.total_formato}</td>   
                                                  </tr>)
                                                }
                                              </tbody>
                                            </table>
                                        </CardBlock>
                                    </Card>
                                )
                              }}
                            />
                        </CardBlock>
                    </Card>
                </div>

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        ticket: state.ticket,
    }
};

export default connect(mapStateToProps, actions)(TicketTable)





// WEBPACK FOOTER //
// ./src/views/reportes/reporteticketsgeneral.js